import { GetSpareStockReqDto } from "@gtpl/shared-models/asset-management";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post, UploadedFile, UseInterceptors } from "@nestjs/common";
import { FileInterceptor } from "@nestjs/platform-express";
import { ApiConsumes, ApiTags } from "@nestjs/swagger";
import { diskStorage } from 'multer';
import path, { extname } from 'path';
import { NameAndDescReqDto } from "./dto/name-desc-req.dto";
import { SpareStockService } from "./spare-stock-service";
const XLSX = require('xlsx');


const fileDirectory = __dirname.replace(/\\dist/, '')




@ApiTags('spareStock')
@Controller('spareStock')
export class SpareStockController {
    constructor(
        private spareStockService: SpareStockService,
        private applicationExceptionHandler: ApplicationExceptionHandler

    ) {

    }



    @Post('getSpareStockDataAgainstToNameAndDesc')
    async getSpareStockDataAgainstToNameAndDesc(@Body() req: NameAndDescReqDto): Promise<CommonResponse> {
        try {
            return await this.spareStockService.getSpareStockDataAgainstToNameAndDesc(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }


    @Post('getSpareStockData')
    async getSpareStockData(@Body() req: GetSpareStockReqDto): Promise<CommonResponse> {
        try {
            return await this.spareStockService.getSpareStockData(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }






    @Post('createSpareStock')
    @ApiConsumes('multipart/form-data')
    @UseInterceptors(FileInterceptor('file', {
        limits: { files: 1 },
        storage: diskStorage({
            destination: path.join(fileDirectory, 'upload-files'),
            filename: (req, file, callback) => {
                const name = file.originalname.split('.')[0];
                const fileExtName = extname(file.originalname);
                const randomName = Array(4)
                    .fill(null)
                    .map(() => Math.round(Math.random() * 16).toString(16))
                    .join('');
                callback(null, `${name}-${randomName}${fileExtName}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(xlsx|xls|csv)$/i)) {
                return callback(new Error('Only Excel files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async uploadFile(@UploadedFile() file, @Body() req: any) {
        try {
            return await this.spareStockService.createSpareStock(file, req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

}